module.exports = __webpack_public_path__ + "static/media/template-2.459b790f.svg";